import React from "react";

import {
  PROFILE_AXES,
  ProfileAxis,
  radarPoints,
  StyleProfile,
} from "../../ShowStylePage/profile";

interface ProfileRadarProps {
  profile: StyleProfile;
  labels: Record<ProfileAxis, string>;
  ariaLabel: string;
}

const RINGS = [8, 16, 24, 32, 40];
const LABEL_RADIUS = 47;

/**
 * Radar of the profile. The outer shape follows the upper ends of the ranges and the inner
 * one the lower ends, so the band in between is what the style allows.
 */
export const ProfileRadar: React.FC<ProfileRadarProps> = ({ profile, labels, ariaLabel }) => (
  <svg className="h-full w-full" viewBox="-12 -4 124 108" role="img" aria-label={ariaLabel}>
    {RINGS.map((radius) => (
      <circle
        key={radius}
        cx="50"
        cy="50"
        r={radius}
        fill="none"
        stroke="#dac2b6"
        strokeWidth="0.5"
        strokeDasharray="2"
      />
    ))}

    {PROFILE_AXES.map((axis, index) => {
      const angle = ((-90 + (360 / PROFILE_AXES.length) * index) * Math.PI) / 180;
      const cos = Math.cos(angle);
      const sin = Math.sin(angle);
      return (
        <g key={axis}>
          <line
            x1="50"
            y1="50"
            x2={50 + 40 * cos}
            y2={50 + 40 * sin}
            stroke="#dac2b6"
            strokeWidth="0.5"
          />
          <text
            x={50 + LABEL_RADIUS * cos}
            y={50 + LABEL_RADIUS * sin}
            fontSize="4"
            fontWeight="700"
            fill={profile[axis] ? "#54433a" : "#b3a49b"}
            textAnchor={Math.abs(cos) < 0.2 ? "middle" : cos > 0 ? "start" : "end"}
            dominantBaseline="middle"
          >
            {labels[axis].toUpperCase()}
          </text>
        </g>
      );
    })}

    <polygon
      points={radarPoints(profile, "max")}
      fill="rgba(254, 147, 44, 0.2)"
      stroke="#fe932c"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <polygon
      points={radarPoints(profile, "min")}
      fill="rgba(254, 147, 44, 0.35)"
      stroke="#904d00"
      strokeWidth="1"
      strokeDasharray="2"
      strokeLinejoin="round"
    />
  </svg>
);
